<p>player-summary works!</p>
